import React from "react";

import "./infoBoxes.css";

interface InfoBoxProps {
    title: string;
    value: number | string;
}

interface MultipleInfoBoxProps {
    title: string[];
    value: number[] | string[];
}

interface InfoBoxesProps {
    infos: (InfoBoxProps | MultipleInfoBoxProps)[];
    backgroundColor?: string;
}

export default function InfoBoxes(props: InfoBoxesProps ) {

    return <div className="info-boxes">
        {props.infos.map((info, index) => {
            // Type guard to check if info is MultipleInfoBoxProps
            if (Array.isArray((info as MultipleInfoBoxProps).title) && Array.isArray((info as MultipleInfoBoxProps).value)) {
                return <div className="info multiple" key={index} style={props.backgroundColor ? { backgroundColor: props.backgroundColor } : {}}>
                    <div className="titles">
                        {(info as MultipleInfoBoxProps).title.map((title, titleIndex) => (
                            <span key={titleIndex}>{title}</span>
                        ))}
                    </div>
                    <div className="values">
                        {(info as MultipleInfoBoxProps).value.map((value, valueIndex) => (
                            <h5 key={valueIndex}>{value}</h5>
                        ))}
                    </div>
                </div>
            }
            return <div className="info" key={index} style={props.backgroundColor ? { backgroundColor: props.backgroundColor } : {}}>
                <span>{(info as InfoBoxProps).title}</span>
                <h2>{(info as InfoBoxProps).value}</h2>
            </div>
    })}
    </div>;

}